module.exports = "/_next/static/images/bank-bca-icon-91759a13736257d34798a9fc6a381115.png";